import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Row as TanstackRow } from '@tanstack/react-table';
import { TableData } from './types';

interface Props<T extends TableData> {
	row: TanstackRow<T>;
	children: React.ReactNode;
	rowId: string;
	enableRowDragAndDrop: boolean;
	gridTemplateColumns?: string;
}

export const MantineTableDraggableRow = <T extends TableData>({
	children,
	rowId,
	enableRowDragAndDrop,
	gridTemplateColumns,
}: Props<T>): React.ReactElement => {
	const { setNodeRef, transform, transition, isDragging, attributes, listeners } = useSortable({
		id: rowId,
		disabled: !enableRowDragAndDrop,
	});

	if (!enableRowDragAndDrop) {
		return children as React.ReactElement;
	}

	const style: React.CSSProperties = {
		gridColumn: '1 / -1',
		display: 'grid',
		gridTemplateColumns: gridTemplateColumns ?? 'inherit',
		transform: CSS.Transform.toString(transform),
		transition,
		opacity: isDragging ? 0.5 : 1,
	};

	return (
		<div ref={setNodeRef} style={style} {...attributes} {...listeners}>
			{children}
		</div>
	);
};
